<template>
  <div class="bg-white dark:bg-gray-800 shadow sm:rounded-lg overflow-hidden">
    <div v-if="name" class="px-4 py-5 sm:px-6 border-b border-gray-200 dark:border-gray-700">
      <h2 class="text-xl font-medium text-gray-900 dark:text-white">
        {{ name }}
      </h2>
      <p v-if="description" class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        {{ description }}
      </p>
    </div>
    <div :class="{ 'px-4 py-5 sm:p-6': name || description }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsCard",
  props: {
    name: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  }
}
</script>
